var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box" }, [
    _c("h1", { staticClass: "subtitle is-5" }, [
      _vm._v("\n    Administrar usuario\n  "),
    ]),
    _vm._v(" "),
    _c("h1", { staticClass: "title is-2" }, [_vm._v("\n    Roles\n  ")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("section", [
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c(
              "b-message",
              { attrs: { type: "is-primary" } },
              [
                _c("h1", { staticClass: "title is-5" }, [
                  _vm._v("Roles activos"),
                ]),
                _vm._v(" "),
                _c("h1", { staticClass: "subtitle is-6" }, [
                  _vm._v("Arrastre aquí para activar"),
                ]),
                _vm._v(" "),
                _c(
                  "draggable",
                  _vm._b(
                    {
                      staticStyle: { "min-height": "25px" },
                      attrs: { tag: "b-taglist" },
                      on: {
                        start: function ($event) {
                          _vm.drag = true
                        },
                        end: function ($event) {
                          _vm.drag = false
                        },
                      },
                      model: {
                        value: _vm.rolesUsr,
                        callback: function ($$v) {
                          _vm.rolesUsr = $$v
                        },
                        expression: "rolesUsr",
                      },
                    },
                    "draggable",
                    { group: "roles" },
                    false
                  ),
                  _vm._l(_vm.rolesUsr, function (rolUsr) {
                    return _c(
                      "b-tag",
                      {
                        key: rolUsr.id,
                        attrs: { type: "is-primary", size: "is-medium" },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.getRoleDescription(rolUsr)) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column" },
          [
            _c(
              "b-message",
              [
                _c("h1", { staticClass: "title is-5" }, [
                  _vm._v("Roles disponibles"),
                ]),
                _vm._v(" "),
                _c("h1", { staticClass: "subtitle is-6" }, [
                  _vm._v("Arrastre aquí para desactivar"),
                ]),
                _vm._v(" "),
                _c(
                  "draggable",
                  _vm._b(
                    {
                      staticStyle: { "min-height": "25px" },
                      attrs: { tag: "b-taglist" },
                      on: {
                        start: function ($event) {
                          _vm.drag = true
                        },
                        end: function ($event) {
                          _vm.drag = false
                        },
                      },
                      model: {
                        value: _vm.rolesOrg,
                        callback: function ($$v) {
                          _vm.rolesOrg = $$v
                        },
                        expression: "rolesOrg",
                      },
                    },
                    "draggable",
                    { group: "roles" },
                    false
                  ),
                  _vm._l(_vm.availableRoles, function (rolOrg) {
                    return _c(
                      "b-tag",
                      {
                        key: rolOrg.id,
                        attrs: { type: "is-dark", size: "is-medium" },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.getRoleDescription(rolOrg)) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "buttons is-right" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.submit()
              },
            },
          },
          [_vm._v("Guardar")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v(
          "\n    Arrastre el rol para asignarle o quitarle el rol. Una vez que finalizó de cargar los datos, presione el botón "
        ),
        _c("i", [_vm._v("Guardar")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }